<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              data-cy="FormSoftSaleStockItem-customerCode"
              v-model="selectedCustomers"
              label="Select a Customer"
              item-text="customerDesc"
              item-value="customerCode"
              :items="customers"
              multiple
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedStockItems"
              data-cy="FormSoftSaleStockItem-itemCode"
              :label="$$t('itemCode')"
              :item-text="i => `${i.itemCode} - ${i.description}`"
              item-value="itemCode"
              :items="stockItems"
              multiple
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormSoftSaleStockItem-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormSoftSaleStockItem-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormSoftSaleStockItem',
  module: 'Shop',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    SoftSaleStockItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localSoftSaleStockItem
      */
      selectedStockItems: [],
      selectedCustomers: [],
    };
  },
  computed: {
    ...mapState('customers', ['customers']),
    ...mapState('stockItems', ['stockItems']),
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        const { selectedCustomers, selectedStockItems } = this;
        this.$emit('save', {
          selectedStockItems,
          selectedCustomers,
        });
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormSoftSaleStockItem example

'''js
<FormSoftSaleStockItem :SoftSaleStockItem="SoftSaleStockItem" />
'''
</docs>
